<!--  -->
<template>
  <div>
    <el-select v-model="advalue" filterable placeholder="请选择">
      <el-option
        v-for="itemsr in adoptions"
        :key="itemsr.admin_id"
        :label="itemsr.admin_name"
        :value="itemsr.admin_id"
      />
    </el-select>
    <div style="margin:20px 0px 0px 0px">
      <el-button type="primary" @click="sumbit">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getadminlist } from '@/api/sourceMaterial.js'
import { editCorpAdmin } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      adoptions: [],
      advalue: null,
      // id: null,
      corp_id: null,
      status: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async adminlist() {
      const data = await getadminlist({
        is_super: this.status
      })
      this.adoptions = data.data.list
      console.log('data', data)
    },
    send(type, item, status) {
      this.status = status
      this.adminlist()
      if (type === 1) {
        this.advalue = null
        // this.id = item.id
        this.corp_id = item.corp_id
      } else {
        this.advalue = item.admin_id
        // this.id = item.id
        this.corp_id = item.corp_id
      }
    },
    async sumbit() {
      if (this.advalue === null) {
        this.$message.error('请选择要修改的管理员')
        return
      }
      const data = await editCorpAdmin({
        // id: this.id,
        admin_id: this.advalue,
        corp_id: this.corp_id
      })
      console.log('data', data)
      this.$emit('updataadmin')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
